export default "__VITE_ASSET__ad5230d8__"